import React from 'react';
import NewPurchaseDebitNote from 'components/Tvendo/Shopping/Operations/DebitNote/NewPurchaseDebitNote';
import { useParams } from 'react-router-dom';
import ViewPurchaseDebitNote from 'components/Tvendo/Shopping/Operations/DebitNote/ViewPurchaseDebitNote';

export default function () {
  const params = useParams();
  if (params.id === '0') {
    return <NewPurchaseDebitNote />;
  }

  return <ViewPurchaseDebitNote />;
}
